import Layout from "./Components/Layout";
import AboutUs from "./Pages/AboutUs/AboutUs";
import { Switch, Route } from "react-router-dom";
import Customers from "./Pages/Customers/Customers";
import Services from "./Pages/Product&Services/Services";
import Procedures from "./Pages/Procedures/Procedures";
import OurVision from "./Pages/OurVison/OurVision";
import GlobalGold from "./Pages/GlobalGold/GlobalGold";
import ContactUs from "./Pages/ContactUs/ContactUs";
import Landing from "./Pages/Landing";
import Preloader from "./Components/Preloader/Preloader";
import axios from "axios";
import { useEffect, useState } from "react";
import "./Responsive.css";

function App() {
  const [lang, setLang] = useState("Fr");
  useEffect(() => {
    if (localStorage.getItem("language") == "En") {
      setLang("En");
    } else if (localStorage.getItem("language") == "Fr") {
      setLang("Fr");
    }
  }, []);

  return (
    <div class="main-wrapper">
      <Preloader />
      <Switch>
        <Layout>
          <Route exact path="/">
            <Landing />
          </Route>
          <Route path="/about-us">
            <AboutUs />
          </Route>
          <Route path="/customers">
            <Customers />
          </Route>
          <Route path="/products-services">
            <Services />
          </Route>
          <Route path="/procedures">
            <Procedures />
          </Route>
          <Route path="/our-vision">
            <OurVision />
          </Route>
          <Route path="/global-gold">
            <GlobalGold />
          </Route>
          <Route path="/contact-us">
            <ContactUs />
          </Route>
        </Layout>
      </Switch>
    </div>
  );
}

export default App;
